// extracted by mini-css-extract-plugin
export var darkMode = "portfolio-module--darkMode--co++N";
export var portfolioContainer = "portfolio-module--portfolioContainer--4yPB8";
export var heroSection = "portfolio-module--heroSection--1t4Cf";
export var statsNumber = "portfolio-module--statsNumber--IOuGl";
export var statsLabel = "portfolio-module--statsLabel--imosl";
export var liveTicker = "portfolio-module--liveTicker--eISYD";
export var pingDot = "portfolio-module--pingDot--q2TGk";
export var ping = "portfolio-module--ping--b85p-";
export var filterPill = "portfolio-module--filterPill--Mt667";
export var filterPillActive = "portfolio-module--filterPillActive--IHtPh";
export var filterPillInactive = "portfolio-module--filterPillInactive--h6tpr";
export var projectCard = "portfolio-module--projectCard--npAlY";
export var dualImageWrapper = "portfolio-module--dualImageWrapper--RAROC";
export var appScreenshot = "portfolio-module--appScreenshot--pXBNZ";
export var appBack = "portfolio-module--appBack--OKkvV";
export var appFront = "portfolio-module--appFront--59ppb";
export var techPill = "portfolio-module--techPill---F9RL";
export var platformIcon = "portfolio-module--platformIcon--0L2TP";
export var viewCaseLink = "portfolio-module--viewCaseLink--voB8y";
export var exploreButton = "portfolio-module--exploreButton--6nAZK";